
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, ElementRef, Injectable, Input, OnInit, TemplateRef, ViewChild, inject, signal } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { EntryData, SimilarStructure, Structure} from '../entry/structure-data.models';
import { MatPaginator } from '@angular/material/paginator';
import { ConfigService } from '../config.service';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '../common.service';
import { GoogleAnalyticsService } from '../google-analytics.service';
import { EntryStatusComponent } from '../entry-status/entry-status.component';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { DomSanitizer } from "@angular/platform-browser";
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { HttpResponse } from '@angular/common/http';
import { PALETTE } from '../molstar-alpha-missense';
import { CheckboxService } from './checkbox.service';
import { Subscription, combineLatest, map } from 'rxjs';
import * as XLSX from 'xlsx';
import { DownloadService } from '../download-service';
import { PlatformService } from '../platform.service';
import { MolstarPluginService } from '../molstar-plugin-service';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EntrySelectors } from '../state/entry.selectors';
import { UtilService } from '../util.service';
import { FoldseekService } from './foldseek.service';
import { DefaultFlexAlignDirective } from '@angular/flex-layout';
declare var PDBeMolstarPlugin: any;

@Injectable({
  providedIn: 'root',
})
export class FoldseekapiService {
    superposeData = [];
    public accession = signal<any>('');
    public afdb_accession = signal<any>('');

    public latest_version = signal<any>('');

    hasStructureData: number;
  
    totalStructure = signal<any>(0);
    totalAFDBStructure = signal<any>(0);
    checked = false;
    disabled = false;
 
    displayedColumnsStructureWithExpand: string[] = ['expand',  'select', 'afdbAccessions', 'descriptions', 'speciesNames','sequenceLength', 'evalue', 'sequenceIdentity', 'resolution', 'alighin3D'];
    pdbStructureDataSource =  signal<any>(new MatTableDataSource<SimilarStructure>());

    displayedColumnsAFDBStructure: string[] = [
      'expand', 
      'select', 
      'afdbAccessions', 
      'speciesNames', 
      'sequenceLength', 
      'evalue', 
      'sequenceIdentity', 
      'averagePlddt', 
      'alighin3D'
    ];
  
    afdbStructureDataSource = signal<any>(new MatTableDataSource<SimilarStructure>());
  
    isStrcutureData: boolean = false;
   
    subTimeout:any;
    isColorby: boolean= true;
    apiData = signal<any>({});
    targetColors = {};
    checkboxState: { [key: string]: boolean } = {};
    disabledState: { [key: string]: boolean } = {};
    private subscription: Subscription;
    private subscription2: Subscription;
  
    structure: Structure;
    pdbeMolstar: any;
    molLoadComplete:boolean = false;
    viewerInstance: any = undefined;
    apiData2 = [];
  
    records="10";
    start="0";

    startPDB = signal<any>("0");
    startAFDB = signal<any>("0");
  
    errorPDB = signal<any>("");
    errorAFDB = signal<any>("");
  
    recordsPDB = signal<any>("10");
    recordsAFDB = signal<any>("10");
  
    currentPDBPage = signal<any>(0);
    currentAFDBPage = signal<any>(0);
  
    sort_direction_PDB = signal<any>('asc'); 
    sort_column_PDB = signal<any>('evalue'); 
  
    sort_direction_AFDB = signal<any>('asc'); 
    sort_column_AFDB = signal<any>('evalue');
  
    species_name_filter_PDB=signal<any>("");
    species_name_filter_AFDB=signal<any>("");
  
    filteritemPDB = signal<any>("");
    filteritemAFDB = signal<any>("");
  
    pdbZeroResultsMsg = signal<any>("");
    afdbZeroResultsMsg = signal<any>("");
  
    isPDBDownloadEnabled = signal<any>(true);
    isAFDBDownloadEnabled = signal<any>(true);
    
    public isOldUniprotEntry: boolean = false;
  
    public entryData = signal<EntryData>({} as EntryData);
    public uniprotData = signal<any>({});
    
    private readonly destroyRef = inject(DestroyRef);
    public foldseekService = inject(FoldseekService);

    public isATBCLoading = signal<any>(false);
    public isBFVDLoading = signal<any>(false);
    public isNTDXLoading = signal<any>(false);

    constructor(
      private sanitizer:DomSanitizer,
      private route: ActivatedRoute,
      private commonService: CommonService,
      public gaService: GoogleAnalyticsService,
      private configService: ConfigService,
     
      private checkboxService: CheckboxService,
     
      private utilService: UtilService,
      private store: Store,
      private molstarPluginService : MolstarPluginService,
    ) {
        this.hasStructureData = -1;
    }
  
    private assignedColor: {[targetId: string]: string} = {};
    private nextColorIndex = 0;
  
    dropdownOptionsPDB: { label: string, value: any, isShow: boolean, disabled?: boolean, info?: string }[];
    dropdownOptionsAFDB: { label: string, value: any, isShow: boolean, disabled?: boolean, info?: string }[];
  
    isDownloadFailed = false;
    isDownloadDone = false;
    isDownloadRunning = false;
    readonly MAX_SELECTION = 100;
    isLimitReachedAFDB = signal<any>(false);
    isLimitReachedPDB = signal<any>(false);
  
    isDisabled = false;
  
    downloadService = inject(DownloadService);
    selectedValuesAFDB = this.downloadService.selectedValuesAFDB;
    allSelectedAFDB = this.downloadService.allSelectedAFDB;
    selectionAFDB= signal<any>(new Set<string>());
  
    selectedValuesPDB = this.downloadService.selectedValuesPDB;
    allSelectedPDB = this.downloadService.allSelectedPDB;
    selectionPDB = signal<any>(new Set<string>());
  
  
    @ViewChild('paginator3',{ static: true }) paginator3!: MatPaginator;
    @ViewChild('paginator4',{ static: true }) paginator4!: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
  
    @ViewChild('tabGroup') tabGroup: MatTabGroup;
   

    public updateisATBCLoading(data:any){
      this.isATBCLoading.set(data);
    }
  
    public updateisNTDXLoading(data:any){
      this.isNTDXLoading.set(data);
    }

    public updateisBFVDLoading(data:any){
      this.isBFVDLoading.set(data);
    }

    expandedElement
    expandRow(element) {
      this.expandedElement = this.expandedElement === element ? null : element
    }
  
    // expandedElements = new Set();
    expandedElements = [];
  
    startStructureSearch(){
      const auth = this.configService.getConfig().apiKey ? `&key=${this.configService.getConfig().apiKey}` : "";
      const configUrl = this.configService.getConfig().structureSearchApiUrl ? this.configService.getConfig().structureSearchApiUrl : "https://test.alphafold.ebi.ac.uk/api/structure/search/";
  
      // const apiUrl = `${configUrl}${this.accession}`;
      const apiUrl = `${configUrl}${this.accession()}?latest_version=${this.latest_version()}${auth}`;
      this.isATBCLoading.set(true);
      this.isBFVDLoading.set(true);
      this.isNTDXLoading.set(true);
      this.commonService.postApiData(apiUrl, {}).subscribe(async (response) => {
        if(response && (response.status == 202)){
          // this.isATBCLoading.set(true);
          // this.isBFVDLoading.set(true);
          // this.isNTDXLoading.set(true);
          // this.isStructureRunning = true;
          // // this.isStructureCach = true; 
          // this.foldseekService.updateStructureRunning(true);
          // this.foldseekService.updateIsStructureCach(true);
          // // this.foldseekapiService.checkAndGetStructureData(this.recordsPDB, this.startPDB, this.sort_direction_PDB, this.sort_column_PDB, this.species_name_filter_PDB);
          // // this.foldseekapiService.checkAndGetAFDBData(this.recordsAFDB, this.startAFDB, this.sort_direction_AFDB, this.sort_column_AFDB, this.species_name_filter_AFDB);
          // this.gaService.eventEmitter(
          //   'foldseek_search', 'FS_similar_structures', 'click', 'foldseek_find_trigger', 'Clicks on the button "Find Similar structures" to trigger search'
          // );
        }
        if(response && (response.status == 200 || response.body?.message.startsWith("There are results for accession"))){
          this.isATBCLoading.set(false);
          this.isBFVDLoading.set(false);
          this.isNTDXLoading.set(false);
          // this.isStructureRunning = false;
          // this.isStructureCach = true; 
          // this.isPDBFoldseekCach = true;
          // this.isAFDBFoldseekCach = true;
  
          // this.foldseekService.updateStructureRunning(false);
          // this.foldseekService.updateIsStructureCach(true);
          // this.foldseekService.updateIsPDBFoldseekCach(true);
          // this.foldseekService.updateIsAFDBFoldseekCach(true);
  
          // this.foldseekapiService.checkAndGetStructureData(this.recordsPDB, this.startPDB, this.sort_direction_PDB, this.sort_column_PDB, this.species_name_filter_PDB);
          // this.foldseekapiService.checkAndGetAFDBData(this.recordsAFDB, this.startAFDB, this.sort_direction_AFDB, this.sort_column_AFDB, this.species_name_filter_AFDB);
          // this.gaService.eventEmitter(
          //   'foldseek_search', 'FS_similar_structures', 'click', 'foldseek_find_trigger', 'Clicks on the button "Find Similar structures" to trigger search'
          // );
        }
      },
      (error) => {
        const code =  error.status;
        if(code === 404){
          // this.isStructureCach = false;
          // this.isStructureRunning = false;
          // this.foldseekService.updateStructureRunning(false);
          // this.foldseekService.updateIsStructureCach(false);
        }
       
        if(code === 422 || code === 302 || code === 500){
          // this.isStructureFail = true;
          // this.foldseekService.updateIsStructureFail(true);
        }
      });
    }

  
    toggleRowPDB(element) {
      this.gaService.eventEmitter(
        'foldseek_expand_seq', 'FS_similar_structures', 'click', 'foldseek_expand_sequence', 'Clicks on the expand row triangle to see sequence alignment on the Foldseek results table'
      );
      // if (this.expandedElements.has(element)) {
      //   this.expandedElements.delete(element);
      // } else {
      //   this.expandedElements.add(element);
      // }
      const ele = this.expandedElements.find(e => e.afdbAccessions === element.afdbAccessions);
      if(ele){
        this.expandedElements = this.expandedElements.filter(el => el.afdbAccessions !== element.afdbAccessions)
      } else {
        this.expandedElements.push(element)
      }
    }
  
    isExpanded(element): boolean {
      // return this.expandedElements.has(element);
      const ele = this.expandedElements.find(e => e.afdbAccessions === element.afdbAccessions);
  
      return ele ? true : false;
  
    }
  
    isExpansionDetailRow = (i: number, row) => this.isExpanded(row);
  
    expandedElementAFDB
    expandRowAFDB(element) {
      this.expandedElementAFDB = this.expandedElementAFDB === element ? null : element
    }
  
    // expandedElementsAFDB = new Set();
    expandedElementsAFDB = [];
    toggleRowAFDB(element ) {
  
      const ele = this.expandedElementsAFDB.find(e => e.afdbAccessions === element.afdbAccessions);
      if(ele){
        this.expandedElementsAFDB = this.expandedElementsAFDB.filter(el => el.afdbAccessions !== element.afdbAccessions)
      } else {
        this.expandedElementsAFDB.push(element)
      }
    }
  
    isExpandedAFDB(element): boolean {
      const ele = this.expandedElementsAFDB.find(e => e.afdbAccessions === element.afdbAccessions);
  
      return ele ? true : false;
    }
  
    isExpansionDetailRowAFDB = (i: number, row) => this.isExpandedAFDB(row);
  
    ngOnInit(): void {
      this.downloadService.updateSelectedValueAFDB([]);
      this.downloadService.updateSelectedValuePDB([]);
      this.subscription = this.checkboxService.checkboxState$.subscribe(state => {
        this.checkboxState = state;
      });
  
      this.checkboxService.disabledState$.subscribe(state => {
        this.disabledState = state;
      });
  
      combineLatest([
        this.store.select(EntrySelectors.entryData).pipe(),
        this.store.select(EntrySelectors.uniprotData).pipe(),
      ])
      .pipe(
        map(([entryData, uniprotData]) => {
          this.entryData.set(entryData)
          this.uniprotData.set(uniprotData)
          
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((data) => {
          if((this.entryData().sequenceVersionDate!= "" || this.entryData().sequenceVersionDate!= null) && (this.uniprotData().sequence.modified != "" || this.uniprotData().sequence.modified != null)){
            this.isOldUniprotEntry = this.utilService.areDatesDifferent(this.entryData().sequenceVersionDate, this.uniprotData().sequence.modified);
          }
      });
  
      // this.checkAndGetStructureData(this.recordsPDB(), this.startPDB(), this.sort_direction_PDB(), this.sort_column_PDB(), this.species_name_filter_PDB());
      // this.checkAndGetAFDBData(this.recordsAFDB(), this.startAFDB(), this.sort_direction_AFDB(), this.sort_column_AFDB(), this.species_name_filter_AFDB());
    }
  
    ngAfterViewInit(): void {
      ////this.changeDetectorRef.detectChanges();
    }
  
    convertFormAFDBIds(ids: string[]): string[] {
      return ids.map(id => {
        // Remove heading 'AF-' and any trailing part starting with '-F1'
        return id.replace(/^AF-/, '').replace(/-F1.*$/, '');
      });
    }
    convertFormPDBIds(ids: string[]): string[] {
      // Remove heading 'AF-' and any trailing part starting with '-F1'
      return ids.map(str => str.split('_')[0]);
    }
    // downloadFrom: string, downloadType: string)
    handleDropdownSelection(event, flag) {
      let tag: string;
      let message: string;
      if(flag === "afdb"){
        this.downloadService.isDownloadRunningAFDB.set(true);
        if(event === "allresultscsv"){
          this.downloadTableInCSV('AFDB');
          tag = "foldseek_AFDB_download_results";
          message = "Clicks on downloading Table results in AFDB tab";
        }
        if(event === "modelcoordicate"){
          const convertedIds = this.convertFormAFDBIds(this.selectedValuesAFDB());
          this.downloadService.updateSelectedValueAFDB(convertedIds);
          this.downloadService.postFile(this.selectedValuesAFDB(), this.accession(), false, flag);
          tag = "foldseek_AFDB_download_coordinates_pae";
          message = "Clicks on downloading Coordinates and PAE of selected structures in AFDB tab";
        }
        this.selectionAFDB().clear();
      }
      if(flag === "pdb"){
        this.downloadService.isDownloadRunningPDB.set(true);
        if(event === "allresultscsv"){
          this.downloadTableInCSV('PDB');
          tag = "foldseek_PDB_download_results";
          message = "Clicks on downloading Table results in PDB tab";
        }
        if(event === "modelcoordicate"){
          const convertedIds = this.convertFormPDBIds(this.selectedValuesPDB());
          this.downloadService.updateSelectedValuePDB(convertedIds);
          this.downloadService.postPDBFile(this.selectedValuesPDB(), this.accession());
          tag = "foldseek_PDB_download_coordinates_pae";
          message = "Clicks on downloading Coordinates and PAE of selected structures in PDB tab";
        }
        this.selectionPDB().clear();
      }
      this.gaService.eventEmitter('foldseek_download', 'FS_similar_structures', 'click', tag, message);
    }
  
    clearSelectionDownload(flag): void {
      if(flag === 'afdb'){
        this.selectionAFDB().clear(); // Empties the selection set
        this.downloadService.updateSelectedValueAFDB([]);
        this.downloadService.updateAllSelectedAFDB(false);
        this.isLimitReachedAFDB.set(false);
        ////this.changeDetectorRef.detectChanges();
      }
      if(flag === 'pdb'){
        this.selectionPDB().clear(); // Empties the selection set
        this.downloadService.updateSelectedValuePDB([]);
        this.downloadService.updateAllSelectedPDB(false);
        this.isLimitReachedPDB.set(false);
        ////this.changeDetectorRef.detectChanges();
      }
    }
  
    checkSelectionLimit(flag) {
      if(flag === "afdb"){
        this.isLimitReachedAFDB.set(this.selectedValuesAFDB().length >= this.MAX_SELECTION);
      }
      if(flag === "pdb"){
        this.isLimitReachedPDB.set(this.selectedValuesPDB().length >= this.MAX_SELECTION);
      }
    }
  
    toggleSelectAllEntries(event: Event, flag: string): void {
      if(flag === 'afdb'){
        const checked = (event.target as HTMLInputElement).checked;
        this.downloadService.updateAllSelectedAFDB(checked);
        // Calculate visible rows on the current page using manual pagination variables
        const startIndex = 0;
        const endIndex = Number(this.recordsAFDB());
        const visibleRows = this.afdbStructureDataSource().filteredData.slice(startIndex, endIndex);
  
        if (this.allSelectedAFDB()) {
          // Add visible rows to the selection if they aren't already selected
          visibleRows.forEach((row) => {
            if (this.selectionAFDB().size < this.MAX_SELECTION) {
              this.selectionAFDB().add(row.targetToShow); // Ensure `row.id` matches your data structure
              const SelectedArr = [...this.selectionAFDB()];
              this.downloadService.updateSelectedValueAFDB(SelectedArr);
            }
          });
        } else {
          // Remove visible rows from selection
          visibleRows.forEach((row) => this.selectionAFDB().delete(row.targetToShow));
          const SelectedArr = [...this.selectionAFDB()];
          this.downloadService.updateSelectedValueAFDB(SelectedArr);
        }
        this.isAllSelectedAFDB();
        this.checkSelectionLimit('afdb');
      }
      if(flag === 'pdb'){
        const checked = (event.target as HTMLInputElement).checked;
        this.downloadService.updateAllSelectedPDB(checked);
        // Calculate visible rows on the current page using manual pagination variables
        const startIndex = 0;
        const endIndex = Number(this.recordsPDB());
        const visibleRows = this.pdbStructureDataSource().filteredData.slice(startIndex, endIndex);
  
        if (this.allSelectedPDB()) {
          // Add visible rows to the selection if they aren't already selected
          visibleRows.forEach((row) => {
            if (this.selectionPDB().size < this.MAX_SELECTION) {
              this.selectionPDB().add(row.targetToShow); // Ensure `row.id` matches your data structure
              const SelectedArr = [...this.selectionPDB()];
              this.downloadService.updateSelectedValuePDB(SelectedArr);
            }
          });
        } else {
          // Remove visible rows from selection
          visibleRows.forEach((row) => this.selectionPDB().delete(row.targetToShow));
          const SelectedArr = [...this.selectionPDB()];
          this.downloadService.updateSelectedValuePDB(SelectedArr);
        }
        this.isAllSelectedPDB();
        this.checkSelectionLimit('pdb');
      }
      
    }
  
    toggleSingleRowSelection(event: Event, elementId: string, flag: string): void {
      if(flag === 'afdb') {
        const checked = (event.target as HTMLInputElement).checked;
    
        if (checked) {
          if (this.selectionAFDB().size < this.MAX_SELECTION) {
            this.selectionAFDB().add(elementId); // Add string to Set
          } else {
            alert('You can select up to 100 rows only.');
          }
        } else {
          this.selectionAFDB().delete(elementId); // Remove string from Set
        }
        const SelectedArr = [...this.selectionAFDB()];
        this.downloadService.updateSelectedValueAFDB(SelectedArr);
        this.isAllSelectedAFDB();
        this.checkSelectionLimit('afdb');
      }
      if(flag === 'pdb') {
        const checked = (event.target as HTMLInputElement).checked;
    
        if (checked) {
          if (this.selectionPDB().size < this.MAX_SELECTION) {
            this.selectionPDB().add(elementId); // Add string to Set
          } else {
            alert('You can select up to 100 rows only.');
          }
        } else {
          this.selectionPDB().delete(elementId); // Remove string from Set
        }
        const SelectedArr = [...this.selectionPDB()];
        this.downloadService.updateSelectedValuePDB(SelectedArr);
        this.isAllSelectedPDB();
        this.checkSelectionLimit('pdb');
      }
    }
    
    isAllSelectedAFDB(): boolean {
      const startIndex = 0;
      const endIndex = Number(this.recordsAFDB());
      const visibleRows = this.afdbStructureDataSource().filteredData.slice(startIndex, endIndex);
      const isallselectedafdb = visibleRows.every(row => this.selectionAFDB().has(row.targetToShow))
      this.downloadService.updateAllSelectedAFDB(isallselectedafdb);
      return isallselectedafdb; // Check by ID
    }
  
    isAllSelectedPDB(): boolean {
      const startIndex = 0;
      const endIndex = Number(this.recordsPDB());
      const visibleRows = this.pdbStructureDataSource().filteredData.slice(startIndex, endIndex);
      const isallselectedpdb = visibleRows.every(row => this.selectionPDB().has(row.targetToShow))
      this.downloadService.updateAllSelectedPDB(isallselectedpdb);
      return isallselectedpdb; // Check by ID
    }
  
    isRowCheckboxDisabledAFDB(): boolean {
      return this.selectionAFDB().size >= this.MAX_SELECTION;
    }
  
    isRowCheckboxDisabledPDB(): boolean {
      return this.selectionPDB().size >= this.MAX_SELECTION;
    }
  
  
    exportSuperpose(){
      PDBeMolstarPlugin.extensions.Foldseek.exportModels(this.viewerInstance);
      this.gaService.eventEmitter('foldseek_download', 'FS_similar_structures', 'click', 'foldseek_download_structures', 'Clicks on the "Download aligned coordinates (mmCIF)" button on the Foldseek similar structure table');
    }
  
    handlePDBError(species_name_filter, errormsg=""){
      // this.hasPDBData = -1;
      this.foldseekService.updateHasPDBData(-1);
      this.totalStructure.set(0);
      this.pdbStructureDataSource.set(null);
  
      if(species_name_filter != ""){
        this.isPDBDownloadEnabled.set(false);
        // this.hasPDBData = 1;
        this.foldseekService.updateHasPDBData(1);
        this.errorPDB.set("No species match your search");
        this.pdbZeroResultsMsg.set("");
      }else{
        if(errormsg.startsWith("The search was completed successfully, but no matching results were found")){
          this.pdbZeroResultsMsg.set("No matching experimentally determined structures were found in the PDB.");
        }else{
          this.pdbZeroResultsMsg.set("");
          this.errorPDB.set("No species match your search");
        }
      }
      ////this.changeDetectorRef.detectChanges();
    }
  
    handleAFDBError(species_name_filter, errormsg){
      // this.hasAFDBData = -1;
      this.foldseekService.updateHasAFDBData(-1);
      this.totalAFDBStructure.set(0);
      this.afdbStructureDataSource.set(null);
     
      if(species_name_filter != ""){
        this.isAFDBDownloadEnabled.set(false);
        // //this.changeDetectorRef.detectChanges();
        // this.hasAFDBData = 1;
        this.foldseekService.updateHasAFDBData(1);
        this.errorAFDB.set("No species match your search");
        if(this.totalStructure() === 0){
          setTimeout(() => {
            this.switchtoTab("afdb");
          }, 0);
        }
        this.afdbZeroResultsMsg.set("");
        
      }else{
        if(errormsg.startsWith("The search was completed successfully, but no matching results were found")){
          this.afdbZeroResultsMsg.set("No matching predicted structures were found in the AlphaFold Database.");
        }else{
          this.afdbZeroResultsMsg.set("");
          this.errorAFDB.set("No species match your search");
        }
      }
      ////this.changeDetectorRef.detectChanges();
    }
  
    switchtoTab(flag) {
      if (this.tabGroup && flag === "afdb" ) {
        this.tabGroup.selectedIndex = 1; 
      } 
      if (this.tabGroup && flag === "pdb" ) {
        this.tabGroup.selectedIndex = 0; 
      }
    }
    handlePageEvent(e, flag){
    
      const start = ((e.pageIndex * e.pageSize)).toString();
      this.records = e.pageSize.toString();
      this.start = start;
  
      this.gaService.eventEmitter(
        'foldseek_table_action', 'FS_similar_structures', 'click', 'foldseek_paginate', 'Clicks on the paginations in the Foldseek results table'
      );
  
      if(flag === "pdb"){
        this.startPDB.set(start);
        this.recordsPDB.set(e.pageSize.toString());
        this.currentPDBPage.set(e.pageIndex);
        let species_name_filter_PDB = "";
        if(this.filteritemPDB() !== ""){
          species_name_filter_PDB = this.filteritemPDB();
        }
        this.checkAndGetStructureData(this.recordsPDB(), start, this.sort_direction_PDB(), this.sort_column_PDB, species_name_filter_PDB);
      }
      if(flag === "afdb"){
        this.startAFDB.set(start);
        this.recordsAFDB.set(e.pageSize.toString());
        this.currentAFDBPage.set(e.pageIndex);
        let species_name_filter_AFDB = "";
        if(this.filteritemAFDB() !== ""){
          species_name_filter_AFDB = this.filteritemAFDB();
        }
        this.checkAndGetAFDBData(this.recordsAFDB(), start, this.sort_direction_AFDB(), this.sort_column_AFDB(), species_name_filter_AFDB);
      }
    }
  
    sortTable(sortState: Sort, flag) {
      let tag = "";
      let gtagmsg = "";
      if(sortState.direction == "asc" && sortState.active == "evalue") {
        tag = "foldseek_evalue_sort_asc";
        gtagmsg = "Clicks on the sort be ascending order for E-value in the Foldseek results table";
      }
      if(sortState.direction == "desc" && sortState.active == "evalue") {
        tag = "foldseek_evalue_sort_desc";
        gtagmsg = "Clicks on the sort be descending order for E-value in the Foldseek results table";
      }
  
      if(sortState.direction == "asc" && sortState.active == "sequenceIdentity") { 
        tag = "foldseek_sequenceidentity_asc";
        gtagmsg = "Clicks on the sort be ascending order for sequence identity in the Foldseek results table";
      }
      if(sortState.direction == "desc" && sortState.active == "sequenceIdentity") {
        tag = "foldseek_sequenceidentity_desc";
        gtagmsg = "Clicks on the sort be descending order for sequence identity  in the Foldseek results table ";
      }
  
      const directions = {
        "ASC": "DESC",
        "DESC": "ASC"
      }
  
      if(flag === "pdb"){
        this.sort_direction_PDB.set(directions[sortState.direction.toUpperCase()]);
        this.sort_column_PDB.set(sortState.active)
        // let species_name_filter_PDB;
        if(this.filteritemPDB() !== ""){
          this.species_name_filter_PDB.set(this.filteritemPDB());
        }
        this.checkAndGetStructureData(this.recordsPDB(), this.startPDB(), this.sort_direction_PDB(), this.sort_column_PDB(), this.species_name_filter_PDB());
      }
      if(flag === "afdb"){
        this.sort_direction_AFDB.set(directions[sortState.direction.toUpperCase()]);
        this.sort_column_AFDB.set(sortState.active)
        // let species_name_filter_AFDB;
        if(this.filteritemAFDB() !== ""){
          this.species_name_filter_AFDB.set(this.filteritemAFDB());
        }
        this.checkAndGetAFDBData(this.recordsAFDB(), this.startAFDB(), this.sort_direction_AFDB(), this.sort_column_AFDB(), this.species_name_filter_AFDB());
      }
      this.gaService.eventEmitter('foldseek_table_action', 'FS_similar_structures', 'click', tag, gtagmsg);
    }
  
    filterTable(filterby, flag){
      if(flag === "pdb"){
        this.currentPDBPage.set(0);
        this.filteritemPDB.set(filterby);
        this.startPDB.set("0");
        this.species_name_filter_PDB.set(filterby);
        this.checkAndGetStructureData(this.recordsPDB(), "0", this.sort_direction_PDB(), this.sort_column_PDB(), filterby);
      }
      if(flag === "afdb"){
        this.currentAFDBPage.set(0);
        this.filteritemAFDB.set(filterby);
        this.startAFDB.set("0");
        this.species_name_filter_AFDB.set(filterby);
        this.checkAndGetAFDBData(this.recordsAFDB(), "0", this.sort_direction_AFDB(), this.sort_column_AFDB(), filterby);
      }
      ////this.changeDetectorRef.detectChanges();
      this.gaService.eventEmitter('foldseek_table_action', 'FS_similar_structures', 'click', 'foldseek_taxfilter', 'Clicks on the "Taxonomy filter" input box on the Foldseek results table');
    }
  
    clearFilter(flag){
      if(flag === "pdb"){
        this.currentPDBPage.set(0);
        this.filteritemPDB.set("");
        this.species_name_filter_PDB.set('');
        this.checkAndGetStructureData(this.recordsPDB(), "0", this.sort_direction_PDB(), this.sort_column_PDB(), "");
      }
      if(flag === "afdb"){
        this.currentAFDBPage.set(0);
        this.filteritemAFDB.set("");
        this.species_name_filter_AFDB.set('');
        this.checkAndGetAFDBData(this.recordsAFDB(), "0", this.sort_direction_AFDB(), this.sort_column_AFDB(), "");
      }
      ////this.changeDetectorRef.detectChanges();
    }
  
    getApiUrl(flag, records, start, sort_direction, sort_column, species_name_filter){
      let apiUrl = "";
      const configUrl = this.configService.getConfig().searchApiUrl ? this.configService.getConfig().searchApiUrl : "https://test.alphafold.ebi.ac.uk/api/search";
  
      apiUrl = `${configUrl}?q=${this.accession()}&type=structure`;
  
      if(flag){
        apiUrl = `${apiUrl}&foldseek_database=`+flag;
      }
  
      if(records){
        apiUrl = `${apiUrl}&rows=`+records;
      }
  
      if(start){
        apiUrl = `${apiUrl}&start=${start}`;
      }
  
      if((sort_column && sort_column != "") && (sort_direction && sort_direction != "")){
        if(sort_column === "evalue")
          apiUrl = apiUrl + '&sort='+sort_column+'+'+sort_direction;
        if(sort_column === "sequenceIdentity")
          apiUrl = apiUrl + '&sort=pident+'+sort_direction;
      }
  
      if (flag === "pdb"){
        if(species_name_filter && species_name_filter != ""){
          apiUrl = apiUrl + '&fq=organismScientificNames%3A*'+species_name_filter.trim()+'*';
        }
      }
      if (flag === "afdb50" || flag === "atbc" || flag === "bfvd" || flag === "ntdx"){
        if(species_name_filter && species_name_filter != ""){
          apiUrl = apiUrl + '&fq=organismScientificName%3A*'+species_name_filter.trim()+'*';
        }
      }
      return apiUrl;
    }
  
    downloadTableInCSV(flag){
      const auth = this.configService.getConfig().apiKey ? `&key=${this.configService.getConfig().apiKey}` : "";
      let apiUrl;
  
      if(flag === "PDB"){
        apiUrl = this.getApiUrl("pdb", "10000", "0", this.sort_direction_PDB(), this.sort_column_PDB(), this.filteritemPDB());
      }
      if(flag === "AFDB"){
        apiUrl = this.getApiUrl("afdb50", "10000", "0", this.sort_direction_AFDB(), this.sort_column_AFDB(), this.filteritemAFDB());
      }
  
      this.commonService.getApiDatawithStatus(apiUrl + auth).subscribe(async (response: HttpResponse<any>) => {
        const code = response.status;
        if(code === 200){
          // this.isStructureCach = true;
          // this.isStructureRunning = false;

          this.foldseekService.updateIsStructureCach(true);
          this.foldseekService.updateStructureRunning(false);

          if( response.body.numFound !== 0){
            const data = response.body.docs;
            const similarStructureData = this.transformStructureDataforCSV(data);
            const fileName = `${this.accession()}_${flag}_FS`;
            const finalData = XLSX.utils.json_to_sheet(similarStructureData);
            const workbook = {
              SheetNames: ['sheet1'], 
              Sheets: {
                sheet1: { ...finalData }, 
              },
            };
            XLSX.writeFile(workbook, `${fileName}.csv`);
            this.downloadService.updateSelectedValue([]);
            this.downloadService.updateAllSelected(false);
            if(flag === "PDB"){
              this.downloadService.isDownloadRunningPDB.set(false);
              this.downloadService.isDownloadDonePDB.set(true);
              this.clearSelectionDownload("pdb");
              if(this.downloadService.isDownloadDonePDB) {
                setTimeout(() => {
                  this.downloadService.isDownloadDonePDB.set(false);
                }, 7000); 
              }
            }
            if(flag === "AFDB"){
              this.downloadService.isDownloadRunningAFDB.set(false);
              this.downloadService.isDownloadDoneAFDB.set(true);
              this.clearSelectionDownload("afdb")
              if(this.downloadService.isDownloadDoneAFDB) {
                setTimeout(() => {
                  this.downloadService.isDownloadDoneAFDB.set(false);
                }, 7000); 
              }
            }
            ////this.changeDetectorRef.detectChanges();
          }else{
            if(flag === "PDB"){
              this.isPDBDownloadEnabled.set(false);
            }
            if(flag === "AFDB"){
              this.isAFDBDownloadEnabled.set(false);
            }
            
          }
        }
      },
      (error) => {
        const code = error.status;
        if(code === 404){
          if(flag === "PDB"){
            this.isPDBDownloadEnabled.set(false);
          }
          if(flag === "AFDB"){
            this.isAFDBDownloadEnabled.set(false);
          }
          ////this.changeDetectorRef.detectChanges();
        }
      });
    }
    updateStructureCacheFlag(flag) {
      this.foldseekService.updateIsStructureCach(this.foldseekService.isPDBFoldseekCach() && this.foldseekService.isAFDBFoldseekCach());
      // this.isStructureCach = this.isPDBFoldseekCach && this.isAFDBFoldseekCach;
    }
  
    checkAndGetStructureData(records="", start="", sort_direction, sort_column, species_name_filter=""){
      const auth = this.configService.getConfig().apiKey ? `&key=${this.configService.getConfig().apiKey}` : "";
  
      const apiUrl = this.getApiUrl("pdb", records, start, sort_direction, sort_column, species_name_filter);
  
      // this.isPDBLoading = true;
      this.foldseekService.updateIsPDBLoading(true);
  
      this.commonService.getApiDatawithStatus(apiUrl + auth).subscribe(async (response: HttpResponse<any>) => {
        const code = response.status;
     
        if(code === 202){
          // this.isPDBFoldseekCach = true;
          // this.isStructureCach = true;
          //  this.isStructureRunning = true;
          this.foldseekService.updateIsPDBFoldseekCach(true);
          this.foldseekService.updateIsStructureCach(true);
          this.foldseekService.updateStructureRunning(true);
         
          if(response.body.message && (response.body.message.startsWith("Foldseek search job is currently running") || response.body.message.startsWith("Initiating new Foldseek search")))
          {
            // this.isStructureRunning = true;
            this.foldseekService.updateStructureRunning(true);
            this.subTimeout = setTimeout(() => {
            if(this.foldseekService.isPDBLoading()) this.checkAndGetStructureData(records, start, sort_direction, sort_column, species_name_filter);
            }, 15000);
          }
        }
       
        if(code === 200){
          
          this.isPDBDownloadEnabled.set(true);
          // this.isStructureCach = true;
          // this.isStructureRunning = false;
          this.foldseekService.updateIsStructureCach(true);
          this.foldseekService.updateStructureRunning(false);
          if( response.body.numFound !== 0){
            const data = response.body.docs;
            this.hasStructureData = 1;
            // this.hasPDBData = 1
            this.foldseekService.updateHasPDBData(1);
            this.errorPDB.set("");
            this.totalStructure.set(response.body.numFound);
            const similarStructureData = this.transformStructureData(data);
            // this.isPDBLoading = false;
            this.foldseekService.updateIsPDBLoading(false);
            // this.initViewer();
            this.pdbStructureDataSource.set(new MatTableDataSource<SimilarStructure>(similarStructureData)); 
            const isallselected = this.isAllSelectedPDB();
            this.downloadService.updateAllSelectedPDB(isallselected);
            this.pdbStructureDataSource().paginator = this.paginator3;
          }
        }
        ////this.changeDetectorRef.detectChanges();
      },
      (error) => {
        const code = error.status;
        // this.isPDBLoading = false;
        this.foldseekService.updateIsPDBLoading(false);
        if(code === 404){
          this.foldseekService.updateStructureRunning(false);
          // this.isStructureRunning = false;
          // this.hasPDBData = -1;
          this.foldseekService.updateHasPDBData(-1);
          this.totalStructure.set(0);
          this.pdbStructureDataSource.set(null);
          ////this.changeDetectorRef.detectChanges();
          if(error.error.message === "Foldseek was not run for this accession."){
            this.foldseekService.updateIsPDBFoldseekCach(false);
            // this.isPDBFoldseekCach = false;
          }else if(error.error.message === "The search was completed successfully, but no matching results were found"){
            // this.isPDBFoldseekCach = true;
            this.foldseekService.updateIsPDBFoldseekCach(true);
            this.handlePDBError("", error.error.message);
          }else if(species_name_filter != ""){
            this.handlePDBError(species_name_filter, error.error.message);
          }
          this.updateStructureCacheFlag("pdb");
        }
        if(code === 422 || code === 302 || code === 500 || code === 0 || code === 429){
          // this.isStructureRunning = false;
          // this.isStructureFail = true;
          this.foldseekService.updateStructureRunning(false);
          // this.foldseekService.updateIsStructureFail(true);
          this.errorPDB().set("There is an issue with this entry. Please report it to us at afdbhelp@ebi.ac.uk and include the accession number you were trying to access.")
          ////this.changeDetectorRef.detectChanges();
        }
        
      });
    }

    getTitle(accession, reviewedStatus, referenceLabel) {
      let tempTitle = "Unavailable";
        
      if(accession){
        if(reviewedStatus && referenceLabel) {
          tempTitle =  `${accession}*${referenceLabel}*${reviewedStatus}`;
        }
        if(reviewedStatus && !referenceLabel){
          tempTitle =  `${accession}*${referenceLabel}*${reviewedStatus}`;
        }
        if(!reviewedStatus && referenceLabel){
          tempTitle =  `${accession}*${referenceLabel}*${reviewedStatus}`;
        }
        if(!reviewedStatus && !referenceLabel){
          tempTitle =  `${accession}*${referenceLabel}*${reviewedStatus}`;
        }
      }
  
      return tempTitle;
    }
  
    tabChanged(tabChangeEvent: MatTabChangeEvent): void {
      const tabLable = tabChangeEvent.tab.textLabel;
      if(tabLable.includes("PDB structures")){
        this.gaService.eventEmitter(
          'foldseek_results', 'FS_similar_structures', 'click', 'foldseek_PDB_structures', 'Click on the tab to see PDB structures'
        );
      }
      if(tabLable.includes("AFDB50 structures")){
        this.gaService.eventEmitter(
          'foldseek_results', 'FS_similar_structures', 'click', 'foldseek_AFDB_structures', 'Click on the tab to see AFDB50 structures'
        );
      }
    }
  
    getLink(database, target) {
      if (database === "pdb") {
        const [entry, ,protein] = target.split("_");
        return protein ? 
          `${this.configService.getConfig().pdbeBaseApiUrl}/entry/pdb/${entry}/protein/${protein}` : 
          `${this.configService.getConfig().pdbeBaseApiUrl}/entry/pdb/${entry}`;
      }
      return `/entry/${target}`;
    }
    
    getResidueRange(database, data){
      let rangetoshow = '';
      if(database === "pdb") {
        if(data.start){
          const length = data.start.length;
          for(let index = 0; index < length; index++){
            const inrangetoshow = `${data.targetAccessions[index]}: ${data.start[index]}-${data.end[index]}`;
      
            if (rangetoshow) {
                rangetoshow += ',  ';  
            }
            rangetoshow += inrangetoshow; 
          }
        }else{
          rangetoshow = "N/A";
        }
      } 
      return rangetoshow
    }
    
    transformAFDBStructureData(data) {
      const similarClusterData = [];
      if(data){
        const databaseInfo = {};

      for (let i = 0; i < data.length; i++) {
        similarClusterData.push({
          "refLinkId": this.getLink(data[i].database, data[i].target),
          "afdbAccessions": this.getTitle(data[i].target, data[i].isUniProtReviewed, data[i].isUniProtReferenceProteome),
          "targetToShow": data[i].modelEntityId,
          "uniprotDescriptions": data[i].uniprotDescription,
          "speciesNames": data[i].organismScientificName ? data[i].organismScientificName : "",
          "sequenceIdentity": data[i].pident ? data[i].pident : "N/A",
          "sequenceLength": data[i].sequenceEnd ? `1-${data[i].sequenceEnd}` : "N/A",
          "evalue": (data[i].evalue != "" || data[i].evalue != null || data[i].evalue != undefined) ? data[i].evalue.toExponential(2) : "N/A",
          "averagePlddt": data[i].globalMetricValue ?  data[i].globalMetricValue : "N/A",
          "alighin3D": this.superposeData.some(entry => entry.accession === data[i].target),
          "expanded": false,
          "hsps" : {
            "current_entry": this.afdb_accession(),
            "accession": data[i].target,
            "query_sequence": data[i].qaln,
            "match_sequence": data[i].qaln,
            "match_accession": data[i].taln,
            "qstart": data[i].qstart,
            "qend": data[i].qend,
            "tstart": data[i].tstart,
            "tend": data[i].tend,
            "sequence_stats": [],
            "targetToShow": data[i].modelEntityId,
          }
        });
  
        const foldseekWithDesc = { 
          ...data[i], 
          targetToShow: data[i].modelEntityId,
          desc: data[i].uniprotDescription, 
          refLinkId: this.getLink(data[i].database, data[i].target),
        };
  
        // data[i].database = "afdb50"
        if (data[i].database === "afdb50") {
          foldseekWithDesc.tstructure = {
            "url": `https://alphafold.ebi.ac.uk/files/${data[i].modelEntityId}-model_v6.bcif`,
            "format": 'cif',
            "binary": true,
          }
        }
        
        databaseInfo[data[i].target] = foldseekWithDesc
        
        this.apiData.set(databaseInfo);
      }
      return similarClusterData;
    }}
  
    transformStructureData(data) {
      const similarClusterData = [];
     
      if(data){
      const databaseInfo = {}
      for (let i = 0; i < data.length; i++) {
        similarClusterData.push({
          "refLinkId": this.getLink(data[i].database, data[i].target),
          "afdbAccessions": this.getTitle(data[i].target, data[i].isUniProtReviewed, data[i].isUniProtReferenceProteome),
          "targetToShow": data[i].database === "pdb" ? data[i].target : data[i].modelEntityId,
          "uniprotDescriptions": data[i].descriptions,
          "speciesNames":data[i].organismScientificNames,
          "sequenceIdentity": data[i].pident ? data[i].pident : "N/A",
  
          "sequenceLength": {
            "start":data[i].uniprotStarts, 
            "end":data[i].uniprotEnds,
            "targetAccessions":data[i].targetAccessions
          },
          "evalue": (data[i].evalue != "" || data[i].evalue != null || data[i].evalue != undefined) ? data[i].evalue.toExponential(2) : "N/A",
          "averagePlddt": data[i].database === "pdb" ? "N/A" : data[i].globalMetricValue,
          "resolution": data[i].database === "pdb" ? data[i].resolution != null ? data[i].resolution.toFixed(2) : "N/A" : "N/A",
          "alighin3D": this.superposeData.some(entry => entry.accession === data[i].target),
          "expanded": false,
          "hsps" : {
            "current_entry": this.afdb_accession(),
            "accession": data[i].target,
            "query_sequence": data[i].qaln,
            "match_sequence": data[i].qaln,
            "match_accession": data[i].taln,
            "qstart": data[i].qstart,
            "qend": data[i].qend,
            "tstart": data[i].tstart,
            "tend": data[i].tend,
            "sequence_stats": [],
            "targetToShow": data[i].database === "pdb" ? data[i].target : data[i].modelEntityId,
          }
        });
  
        const foldseekWithDesc = { 
          ...data[i], 
          targetToShow: data[i].database === "pdb" ? data[i].target : data[i].modelEntityId,
          desc: data[i].database === "pdb" ? data[i].descriptions[0] : data[i].uniprotDescription, 
          refLinkId: this.getLink(data[i].database, data[i].target),
        };
  
        if (data[i].database === "afdb50") {
          foldseekWithDesc.tstructure = {
            "url": `https://alphafold.ebi.ac.uk/files/${data[i].modelEntityId}-model_v6.bcif`,
            "format": 'cif',
            "binary": true,
          }
        }
        
        databaseInfo[data[i].target] = foldseekWithDesc
       
        this.apiData.set(databaseInfo);
      }
      return similarClusterData;
    }}
  
    transformStructureDataforCSV(data) {
      const tableCSVData = [];
      if(data){
      for (let i = 0; i < data.length; i++) {
  
        let dataObj: any = {
          "Sr.No.": i+1
        }
        
        if (data[i].database === "pdb") {
          dataObj["PDB ID and chain"] = data[i].target 
          dataObj["Description"] = data[i].descriptions.join(', ')
          dataObj["Species"] = data[i].organismScientificNames.join(', ')
          dataObj["Residue Range"] = this.getResidueRange(data[i].database, {"start":data[i].uniprotStarts,"end":data[i].uniprotEnds,"targetAccessions":data[i].targetAccessions} )
          dataObj["E-value"] = (data[i].evalue != "" || data[i].evalue != null || data[i].evalue != undefined) ? data[i].evalue.toExponential(2) : "N/A",
          dataObj["Sequence identity"] = data[i].pident ? data[i].pident+"%" : "N/A"
        }
  
        if (data[i].database === "afdb50") {
          dataObj["AFDB accession"] =  data[i].modelEntityId
          dataObj["Description"]=  data[i].uniprotDescription ? data[i].uniprotDescription : "N/A" 
          dataObj["Species"] = data[i].organismScientificName ? data[i].organismScientificName : "N/A"
          dataObj["Residue Range"] =  data[i].sequenceEnd ?  `1-${data[i].sequenceEnd}` : "N/A"
          dataObj["E-value"] = data[i].evalue ? (data[i].evalue.toExponential(2)).toString() : "N/A"
          dataObj["Sequence identity"] = data[i].pident ? data[i].pident+"%" : "N/A"
        }
  
        if (data[i].database === "pdb") {
          dataObj["Resolution (Å)"] = data[i].resolution != null ? data[i].resolution.toFixed(2) : "N/A";
        }
  
        if (data[i].database === "afdb50") {
          dataObj["Reviewed status"] = data[i].isUniProtReviewed,
          dataObj["Reference proteome status"] = data[i].isUniProtReferenceProteome,
          dataObj["Average pLDDT"] = data[i].globalMetricValue;
        }
        dataObj = {
          ...dataObj,
          "Query start position" : data[i].qstart,
          "Query end position" : data[i].qend,
          "Aligned query sequence with gaps" : data[i].qaln,
          
          "Target start position" : data[i].tstart,
          "Target end position" : data[i].tend,
          "Aligned target sequence with gaps": data[i].taln,
        }
        tableCSVData.push(dataObj);
      }
      return tableCSVData;
    }}

    checkAndGetAFDBData(records="", start="", sort_direction, sort_column, species_name_filter=""){
      const auth = this.configService.getConfig().apiKey ? `&key=${this.configService.getConfig().apiKey}` : "";
    
      const apiUrl = this.getApiUrl("afdb50", records, start, sort_direction, sort_column, species_name_filter);
  
      // this.isAFDBLoading = true;
      // this.foldseekService.updateIsAFDBLoading(true);
      this.commonService.getApiDatawithStatus(apiUrl + auth).subscribe(async (response: HttpResponse<any>) => {
        const code = await Number(response.status);
        if(code === 202){
          // this.isAFDBFoldseekCach = true;
          // this.isStructureCach = true;
          // this.isStructureRunning = true;
          this.foldseekService.updateIsAFDBFoldseekCach(true);
          this.foldseekService.updateIsStructureCach(true);
         this.foldseekService.updateIsAFDBLoading(true);
          if(response.body.message && (response.body.message.startsWith("Foldseek search job is currently running") || response.body.message.startsWith("Initiating new Foldseek search")))
          {
            // this.isStructureRunning = true;
            //this.foldseekService.updateStructureRunning(true);
            this.subTimeout = setTimeout(() => {
            if(this.foldseekService.isAFDBLoading) this.checkAndGetAFDBData(records, start, sort_direction, sort_column, species_name_filter);
            }, 15000);
          }
        }
        if(code === 200){
          
          this.isAFDBDownloadEnabled.set(true);
          // this.isStructureCach = true;
          // this.isStructureRunning = false;
          this.foldseekService.updateIsStructureCach(true);
          this.foldseekService.updateStructureRunning(false);
          if( response.body.numFound !== 0){
            const data = response.body.docs;
            this.hasStructureData = 1;
            // this.hasAFDBData = 1;
            this.foldseekService.updateHasAFDBData(1);
            this.errorAFDB.set("");
            this.totalAFDBStructure.set(response.body.numFound);
            const similarStructureData = this.transformAFDBStructureData(data);
            // this.isAFDBLoading = false;
            this.foldseekService.updateIsAFDBLoading(false);
            this.afdbStructureDataSource.set(new MatTableDataSource<SimilarStructure>(similarStructureData));    
            const isallselected = this.isAllSelectedAFDB();
            this.downloadService.updateAllSelectedAFDB(isallselected);
            this.afdbStructureDataSource().paginator = this.paginator3;
          }
        }
        ////this.changeDetectorRef.detectChanges();
      },
      (error) => {
        const code = error.status;
        // this.isAFDBLoading = false;
        this.foldseekService.updateIsAFDBLoading(false);
        if(code === 404){
          // this.isStructureRunning = false;
          // this.hasAFDBData = -1;
          this.foldseekService.updateStructureRunning(false);
          this.foldseekService.updateHasAFDBData(-1);
          this.totalAFDBStructure.set(0);
          this.afdbStructureDataSource.set(null);
  
          if(error.error.message === "Foldseek was not run for this accession."){
            // this.isAFDBFoldseekCach = false;
            this.foldseekService.updateIsAFDBFoldseekCach(false);
          }else if(error.error.message === "The search was completed successfully, but no matching results were found"){
            // this.isAFDBFoldseekCach = true;
            this.foldseekService.updateIsAFDBFoldseekCach(true);
            this.handleAFDBError("", error.error.message);
          }else if(species_name_filter != ""){
            this.handleAFDBError(species_name_filter, error.error.message);
          }
          this.updateStructureCacheFlag("afdb");
        }
        if(code === 422 || code === 302 || code === 500 || code === 0 || code === 429){
          // this.isStructureCach = false;
          // this.isStructureRunning = false;
          // this.isStructureFail = true;
          this.foldseekService.updateIsStructureCach(false);
          this.foldseekService.updateStructureRunning(false);
          // this.foldseekService.updateIsStructureFail(false);
          this.afdbZeroResultsMsg.set("There is an issue with this entry. Please report it to us at afdbhelp@ebi.ac.uk and include the accession number you were trying to access.")
          ////this.changeDetectorRef.detectChanges();
        }
      });
    }
}